module.exports = __webpack_public_path__ + "static/media/torso-top-right-side.8c085957.png";